<template>
  <div>
    <!-- User Interface controls -->
    <b-row>
      <b-col md="7" class="my-1">
        <b-form-group class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Type to Search" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="5" class="my-1">
        <b-form-group label-cols-md="4" label="Per page" class="mb-0">
          <b-form-select :options="pageOptions" v-model="perPage" />
        </b-form-group>
      </b-col>
    </b-row>

    <!-- Main table element -->
    <b-table show-empty empty-text="There are no users at this time." striped responsive stacked="md" :items="items"
      :fields="fields" :filter="filter" :current-page="currentPage" :per-page="perPage" :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc" @filtered="onFiltered">
      <template v-slot:cell(name)="row">
        {{ row.item.name }}<span v-if="role == 'admin'"> - {{ row.item.id }}</span>
        <div v-if="user.role === 'school' && (row.item.roles[0].type === 'student' || row.item.roles[0].type === 'instructor')">
          <div v-if="!row.item.campus" class="text-danger">Campus:</div>
          <div v-else>Campus: {{ row.item.campus }}</div>
          <b-form-select label="Campus" v-model="row.item.selected">
            <option>St. John's</option>
            <option>Bay St. George</option>
            <option>EMR to PCP</option>
          </b-form-select>
          <b-button
              @click="changeCampus(row.item.id, row.item.selected)"
              class="btn btn-primary"
          >
            <span class="icon icon-shareable"></span>
          </b-button>
        </div>
        <div v-if="row.item.added_by">
          Added by: <span class="text-success">{{ row.item.added_by }}</span>
        </div>
        <div v-if="row.item.last_active_at" class="text-warning">
          Last Active: {{ moment(row.item.last_active_at).format('MMM DD YYYY HH:mm:ss') }}
        </div>
      </template>
      <template v-slot:cell(roles)="row">
        {{ row.item.roles[0].type }}
        <div v-if="row.item.year">Year: {{ row.item.year }}</div>
        <div v-if="user.role === 'school' && row.item.roles[0].type === 'student' && !row.item.year">
          <div v-for="role in row.item.roles" :key="role.id">
            <div>Year: {{ row.item.year }}</div>
            <b-form-select label="Year" v-model="row.item.selected">
              <option>{{ moment().add(2, 'year').year() }}</option>
              <option>{{ moment().add(1, 'year').year() }}</option>
              <option>{{ moment().year() }}</option>
              <option>{{ moment().subtract(1, 'year').year() }}</option>
              <option>{{ moment().subtract(2, 'year').year() }}</option>
            </b-form-select>
            <b-button
                @click="changeYear(row.item.id, row.item.selected)"
                class="btn btn-primary"
            >
              <span class="icon icon-shareable"></span>
            </b-button>
          </div>
        </div>
      </template>
      <template v-slot:cell(hospital)="row">
        <div v-for="(hospital, index) in row.item.hospital" :key="index">
          {{ hospital.hospital }} <span v-if="role == 'admin'">- {{ hospital.id }}</span><br>
        </div>
      </template>
      <template v-slot:cell(actions)="row" class="text-nowrap">
        <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
        <b-button-group v-if="role !== 'admin'">
          <b-dropdown variant="success" right text="Actions">
            <b-dropdown-item @click.stop="editPreceptor(row.item.id)">Edit</b-dropdown-item>
            <b-dropdown-item @click.stop="rebootUser(row.item.id, row.item.email)">Reset Account</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item v-if="row.item.roles[0]['type'] === 'student'" @click.stop="auditUser(row.item.id)">Duplicate for Audit</b-dropdown-item>
            <b-dropdown-item @click.stop="info(row.item.name, row.item.id, $event.target)">Delete User
            </b-dropdown-item>
          </b-dropdown>
        </b-button-group>
        <b-button-group class="mt-2" v-if="role == 'admin'">
          <b-button variant="info" @click.stop="impersonateUser(row.item.id)"><i aria-hidden="true" class="fa fa-user-secret"></i></b-button>
          <b-dropdown variant="success" right text="Actions">
            <b-dropdown-item @click.stop="editPreceptor(row.item.id)">Edit</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click.stop="rebootUserAdmin(row.item.id, row.item.email)">Reset</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click.stop="info(row.item.name, row.item.id, $event.target)">Delete User
            </b-dropdown-item>
          </b-dropdown>
        </b-button-group>
        <b-button-group class="mt-2" v-if="role == 'admin'">
          <b-button class="btn btn-primary" :class="{'btn btn-danger' : done == row.item.id}" @click.stop="resetPassword(row.item.id)"><span
              class="icon icon-mail"> New</span>
          </b-button>
        </b-button-group>
      </template>
    </b-table>
    <!-- Info modal -->
    <b-modal ok-title="Yes Delete" cancel-title="Cancel" ok-variant="danger" cancel-variant="primary" id="modalInfo"
      @hide="resetModal" @ok="deletePreceptor" :title="modalInfo.title">
      <h4>{{ modalInfo.content }}</h4>
    </b-modal>

    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
const items = [];
var moment = require('moment');
export default {
  props: ["users", "eurl", "durl", "user_role"],
  data() {
    return {
      items: this.users,
      moment: moment,
      user: window.User,
      role: this.user_role,
      editUrl: this.eurl,
      deleteUrl: this.durl,
      fields: [{
          key: "name",
          label: "Name",
        },
        {
          key: "roles",
          label: "Role"
        },
        {
          key: "hospital",
          label: "Hospital"
        },
        {
          key: "actions",
          label: "Actions"
        }
      ],
      filter: null,
      done: null,
      reset: null,
      active: 'btn btn-success',
      sortBy: 'name',
      sortDesc: false,
      currentPage: 1,
      perPage: 25,
      totalRows: this.users.length,
      pageOptions: [15, 25, 35, 50],
      modalInfo: {
        title: '',
        content: '',
        id: ''
      }
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return {
            text: f.label,
            value: f.key
          };
        });
    }
  },
  filters: {
    uppercase: function (v) {
      return v.toUpperCase();
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    info(name, id, button) {
      this.modalInfo.title = `Are you sure you want to delete?`
      this.modalInfo.content = name
      this.modalInfo.id = id
      this.$root.$emit('bv::show::modal', 'modalInfo', button)
    },
    resetModal() {
      this.modalInfo.title = ''
      this.modalInfo.content = ''
      this.modalInfo.id = ''
    },
    impersonateUser(id) {
      window.location.href = '/impersonate/' + id;
    },
    changeYear(user, year) {
      axios
          .post('/school/user/year', {
            user_id: user,
            year: year
          })
          .then(response => (this.items = response.data))
          .catch(function(error) {
            // handle error
            console.log(error);
          });
    },
    changeCampus(user, campus) {
      axios
          .post('/school/user/campus', {
            user_id: user,
            campus: campus
          })
          .then(response => (this.items = response.data))
          .catch(function(error) {
            // handle error
            console.log(error);
          });
    },
    deletePreceptor(id) {
      this.modalInfo.title = ''
      this.modalInfo.content = ''
      axios.get(this.deleteUrl + 'delete/' + this.modalInfo.id)
        .then(response => this.items = response.data)
        .catch(function (error) {
          // handle error
          console.log(error);
        });
      swal({
        title: "User Deleted!",
        icon: "success"
      });
    },
    auditUser(id) {
      swal("Audit User!", "Would you like to duplicate this student's activities to create an Audit account?", {
        buttons: {
          cancel: "Cancel",
          now: "Yes, Create Audit"
        },
      }).then(now => {
        if (now) {
          axios.post('/create-audit', {
            user_id: id
          }).then(response => this.items = response.data)
        }
      });
    },
    editPreceptor(id) {
      window.location.href = this.editUrl + 'edit/' + id;
    },
    resetPassword(id) {
      axios.get('/user/reset/' + id)
        .catch(function (error) {
          // handle error
          console.log(error);
        });
      this.done = id;
    },
    rebootUser(id, email) {
      axios.post('/user/reboot', {
          user_id: id,
          email: email
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        });
      swal({
        title: "User Info Reset!",
        icon: "success"
      });
    },
    rebootUserAdmin(id, email) {
      axios.post('/user/reboot', {
          user_id: id,
          email: email
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        });
      this.reset = id
    },
  }
};
</script>

<!-- table-complete-1.vue -->